@if (flow === 'provider' || flow === 'employer' || flow === 'contractor' || flow === 'conservator' || flow === 'independentFacilitator'
  || flow === 'vendor' || flow === 'authRepresentative' || flow === 'poa' || flow === 'legalGuardian') {
  @if (mode === 'search') {
    <ppl-provider-search-and-select
      [providerType]="providerType"
      (providerSelected)="handleProviderSelected($event)"
      (cancel)="onCancel()"
      (addingNewProvider)="handleAddNewProvider()"
    >
    </ppl-provider-search-and-select>
  } @if (mode === 'edit' || mode === 'add') {
    <ppl-enrollment-info [source]="'enrollment'" (employerTaskManagerValue)="onEmployerTaskManagerValueChange($event)"></ppl-enrollment-info>
    <ppl-enrollment-contact-details [source]="'enrollment'" 
    [isEmployerTaskManagerSelf]="isEmployerTaskManagerSelf" [contactDetailsData]="contactDetails"></ppl-enrollment-contact-details>
    <ppl-enrollment-comm-preferences
      [source]="'enrollment'"
    ></ppl-enrollment-comm-preferences>
    <ppl-enrollment-service-details
      [source]="'enrollment'"
    ></ppl-enrollment-service-details>
  }
}
<!-- @else {
  <ppl-enrollment-info [source]="'enrollment'"></ppl-enrollment-info>
  <ppl-enrollment-contact-details
    [source]="'enrollment'"
  ></ppl-enrollment-contact-details>
  <ppl-enrollment-comm-preferences
    [source]="'enrollment'"
  ></ppl-enrollment-comm-preferences>
  <ppl-enrollment-service-details
    [source]="'enrollment'"
  ></ppl-enrollment-service-details>
} -->
